import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from 'shell-models-lib';

import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';
import { TeradataDataset } from 'app/model/dataset/teradata.dataset';
import { Metamodel } from 'app/model/base/model';
import _ from 'lodash';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(TeradataDataset),
    asynchronous: true,
    adapts: _.merge({
        properties: {
            typeProperties: {
                database: '*'
            }
        }
    }, tabularTypeDatasetAdapts)
})
export class TeradataDatasetAdapter extends TabularTypeDatasetAdapter<TeradataDataset, Model.DatasetResource> {
    protected model(): IModel {
        return TeradataDataset.MODEL;
    }

    protected async _toResource(dataset: TeradataDataset): Promise<Model.DatasetResource>{
        return await this._toResourceInternal(dataset, this.model().name, undefined, 'database');
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: TeradataDataset): Promise<TeradataDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, this.model(), undefined, 'database');
    }
}
